import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from "@reduxjs/toolkit";

import { getAllProducts } from "./thunk";

const thunks = [getAllProducts];

const initialState = {
  status: "idle",
  Products: {},
};

export const slice = createSlice({
  name: "products",
  initialState,
  reducers: {
    // setEmail: (state, email) => {
    //   state.userEmail = email;
    // },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(postLogin.fulfilled, (state, action) => {
      //   state.status = "idle";
      //   state.Login = action.payload;
      //   console.log(state);
      // })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.status = "idle";
        state.Products = action.payload;
      })
      .addMatcher(isPending(...thunks), (state) => {})
      .addMatcher(isFulfilled(getAllProducts), (state) => {})
      .addMatcher(isRejected(...thunks), (state, action) => {});
  },
});

// export action from slice
// export const { setEmail } = slice.actions;

export const getProducts = (state) => state.products.Products;
// export const selectUser = (state) => state.login.userDetail;
// export const selectEmail = (state) => state.login.userEmail;

export default slice.reducer;
